angular
    .module('eficienciaFiscalModule')
    .filter('array', () => {
        return (input) => input.join(', ');
    });
